import React  from 'react'
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TipaltiExportPanel from '../EvaluatorAdmin/TipaltiExportPanel';


class EvaluatorExport extends React.Component  
{

    static defaultProps={
    };

    constructor(props) 
    {
        super(props);
        this.state = {
            // shownPanel:ShownPanelsEnum.Export,
            shownPanel:ShownPanelsEnum.None,
        };
    }

    componentDidMount() 
    {
        
    }

    showPanel(newPanel)
    {
        if(newPanel===ShownPanelsEnum.Refresh) 
        {
            this.render();
            newPanel=ShownPanelsEnum.None;
        }
        newPanel=newPanel===this.state.shownPanel?ShownPanelsEnum.None:newPanel;
        this.setState({shownPanel:newPanel})
    }

    // renderButtonRow()
    // {
    //     return(
    //         <ButtonRow
    //             labels={["Refresh"]}
    //             keys={[ShownPanelsEnum.Refresh]}
    //             icons={["fa-solid fa-refresh"]}
    //             value={this.state.shownPanel}
    //             onClick={this.showPanel.bind(this)}
    //         />
    //     );
    // }

    renderPanels()
    {
        switch (this.state.shownPanel) {
            case ShownPanelsEnum.Export:
                return(
                    <TipaltiExportPanel
                        clickOnCancel={()=> this.setState({shownPanel:ShownPanelsEnum.None})}
                    />
                );
        
            default:
                break;
        }
        return null;
    }

    render()
    {
        
        return (
            <div className='contentwrapper'>
                {/* {this.renderButtonRow()} */}
                {this.renderPanels()}

            </div>
        );
    }
}


export default EvaluatorExport;
